import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Outlet, useNavigate } from "react-router-dom";
import { clearSession } from "../store/scheduler";

// Re-entering the booking steps after an appointment is booked starts a new one.
export default function BookingGuard() {
  const confirmationNumber = useSelector(
    (state) => state.scheduler.confirmationNumber
  );
  const urlSlug = useSelector((state) => state.scheduler.franchise.urlSlug);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [blocked, setBlocked] = useState(Boolean(confirmationNumber));

  useEffect(() => {
    if (!blocked) return;
    dispatch(clearSession());
    navigate(urlSlug ? `/${urlSlug}/` : "/no-location", { replace: true });
    setBlocked(false);
  }, []);

  return blocked ? null : <Outlet />;
}
